import Vue from 'vue'
import App from './App.vue'
import VueTour from 'vue-tour'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-tour/dist/vue-tour.css';

import VueRouter from 'vue-router';
import {routes} from './routes.js';

import {store} from './store';

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;


Vue.use(VueRouter);
Vue.use(VueTour);

const router = new VueRouter({
	mode: 'history',
	routes
});

new Vue({
	render: h => h(App),
	router,
	store,
}).$mount('#app');


